/**
 * Handle login / registration / update profile errors
 */
export default {
    props: {
      /**
       * Errors translation labels
       */
      errors: {
        type: Object,
        default: () => { return { Woops: 'Internal Error' } }
      }
    },
    methods: {
      /**
       * @vuese
       * Error handling function
       */
      errorHandlingAction(error) {
        this.$logger.debug(error)
        let message = this.errors.Woops
        if (error?.responseJSON?.errors) {
          const { errors } = error.responseJSON
          if (errors && typeof errors === 'object') {
            message = Object.values(errors)[0]
          }
        }
        this.serverErrors.push({
          code: 400,
          message
        })
      }
    }
  }